<template lang="pug">
	<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-label="Icons / Search / Black">
		<defs>
			<path d="M11.4210753,10.1306108 L10.7414307,10.1306108 L10.500544,9.89832723 C11.5329155,8.69389374 12.0663075,7.05070234 11.7738022,5.30427379 C11.3694567,2.91261301 9.37353835,1.00272563 6.96467138,0.710220352 C3.32556164,0.262859343 0.262859343,3.32556164 0.710220352,6.96467138 C1.00272563,9.37353835 2.91261301,11.3694567 5.30427379,11.7738022 C7.05070234,12.0663075 8.69389374,11.5329155 9.89832723,10.500544 L10.1306108,10.7414307 L10.1306108,11.4210753 L13.7869268,15.0773912 C14.1396537,15.4301182 14.7160612,15.4301182 15.0687881,15.0773912 L15.0687881,15.0773912 C15.4215151,14.7246643 15.4215151,14.1482568 15.0687881,13.7955299 L11.4210753,10.1306108 Z M6.25921748,10.1306108 C4.1170465,10.1306108 2.38782414,8.40138847 2.38782414,6.25921748 C2.38782414,4.1170465 4.1170465,2.38782414 6.25921748,2.38782414 C8.40138847,2.38782414 10.1306108,4.1170465 10.1306108,6.25921748 C10.1306108,8.40138847 8.40138847,10.1306108 6.25921748,10.1306108 Z" id="path-1"/>
		</defs>
		<g id="Explorations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g id="SFC_Mobile_Menu_Opened_1" transform="translate(-16.000000, -360.000000)">
				<g id="Group-4" transform="translate(16.000000, 80.000000)">
					<g id="Group-3-Copy-4" transform="translate(0.000000, 278.000000)">
						<g id="Icons-/-Search" transform="translate(0.000000, 2.000000)">
							<rect id="Rectangle" fill-opacity="0" fill="#D8D8D8" x="0" y="0" width="16" height="16"/>
							<mask id="mask-2" fill="white">
								<use xlink:href="#path-1"/>
							</mask>
							<use id="Mask" fill="#303030" fill-rule="nonzero" xlink:href="#path-1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<style lang="stylus" scoped>

</style>

<script>
export default {
	methods:{
		emitClick(event){
			this.$emit('click', event)
		}
	}
}
</script>
